export enum FileMenuActions {
  New = 'New',
  Open = 'Open',
  Save = 'Save',
  SaveAs = 'SaveAs',
  Upload = 'Upload',
  Download = 'Download',
  Print = 'Print',
}

export enum OpenMenuItems {
  ClientCase = 'ClientCase',
  Browse = 'Browse',
  ThisPC = 'ThisPC',
}
